import Authenticated from 'src/components/Authenticated';
import PublicRoute from 'src/components/PublicRoute';
import SelfSignUp from 'src/components/Signup';
import { IS_MTP_DEPLOYMENT, IS_SELF_SIGNUP_ENABLED } from 'src/config';
import PrivacyPolicy from 'src/content/pages/PrivacyPolicy';
import Status404 from 'src/content/Status404';
import TenantDiscovery from 'src/content/TenantDiscovery';
import BaseLayout from 'src/layouts/BaseLayout';
import SidebarV2Layout from 'src/layouts/SidebarV2/Layout';
import { isDefaultDomain, isPublicRoute } from 'src/utils/utils';

import mainRoutes from './dashboards';

const router = (userAppPermissions) => {
  if (isPublicRoute()) {
    const publicRoutes = [
      {
        path: '/privacypolicy',
        element: <PrivacyPolicy />
      },
      {
        path: '*',
        element: <BaseLayout />,
        children: [
          {
            path: '*',
            element: <Status404 />
          }
        ]
      }
    ];

    if (IS_MTP_DEPLOYMENT) {
      publicRoutes.push({
        path: '/',
        element: <PublicRoute element={<TenantDiscovery />} />
      });
    }

    if (IS_SELF_SIGNUP_ENABLED && IS_MTP_DEPLOYMENT && isDefaultDomain()) {
      publicRoutes.push({
        path: '/signup',
        element: <PublicRoute element={<SelfSignUp />} />
      });
    }

    return publicRoutes;
  }

  return [
    {
      path: '/',
      element: (
        <Authenticated>
          <SidebarV2Layout />
        </Authenticated>
      ),
      children: [
        {
          path: '/',
          children: mainRoutes(userAppPermissions)
        }
      ]
    },
    {
      path: '*',
      element: <BaseLayout />,
      children: [
        {
          path: '*',
          element: <Status404 />
        }
      ]
    }
  ];
};

export default router;
